import { selectCountries } from "../../../../components/appData.slice";
import { FormElement, FormId } from "../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../components/types";
import { Url } from "../../../../router/enums";
import { provinces } from "../../../../shared";
import { selectIsDefaultCountrySelected } from "../../../../store/HOC/genericUI.selectors";
import {
  selectIncidentCircumstancesData,
  selectUIData,
} from "../incident.selectors";
import { setUIField } from "../incident.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.INCIDENT_CIRCUMSTANCES,
  selector: selectIncidentCircumstancesData,
  redirect: Url.AC_PERPETRATOR,
  content: [
    {
      title: "Okoliczności zdarzenia",
      sections: [
        {
          id: "incident-circumstances-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.DATE_PICKER,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_DATE,
              required: true,
              isSubmitted: false,
              label: "Data zdarzenia",
            },
            {
              type: FormElement.TIME_PICKER,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_HOUR,
              required: true,
              label: "Godzina zdarzenia",
            },
          ],
        },
        {
          id: "incident-circumstances-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_PLACE,
              required: true,
              label: "Miejsce zdarzenia",
              placeholder:
                "Podaj dane miejsca zdarzenia: nazwa ulicy lub skrzyżowanie ulic, " +
                "nr domu, nazwa ronda, lub inny charakterystyczny punkt np. 245 km trasy A2.",
              limit: 250,
            },
          ],
        },
        {
          id: "incident-circumstances-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_COUNTRY,
              onChange: setUIField,
              items: selectCountries,
              required: true,
              label: "Kraj",
            },
            {
              type: FormElement.SELECT,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_PROVINCE,
              disabled: selectIsDefaultCountrySelected(selectUIData)(
                "circumstances[country]"
              ),
              label: "Województwo",
              required: true,
              items: [...provinces],
            },
          ],
        },
        {
          id: "incident-circumstances-data-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_CITY,
              required: true,
              label: "Miejscowość",
            },
          ],
        },
        {
          id: "incident-circumstances-data-5",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.INCIDENT_CIRCUMSTANCES_DESCRIPTION,
              required: true,
              placeholder:
                "Opisz okoliczności i przebieg zdarzenia (np. Zatrzymałem się na czerwonym świetle, " +
                "a sprawca nie zachował należytej ostrożności i uderzył w tył mojego auta)",
              limit: 10000,
              label: "Opis zdarzenia",
            },
          ],
        },
      ],
    },
  ],
};
